import React, { useState } from 'react';
import { X } from 'lucide-react';

const TagInput: React.FC<{
  values: string[];
  onChange: (v: string[]) => void;
  placeholder: string;
  tagColor: string;
  tagBg: string;
}> = ({ values, onChange, placeholder, tagColor, tagBg }) => {
  const [input, setInput] = useState('');

  const add = (raw: string) => {
    const trimmed = raw.trim();
    if (trimmed && !values.includes(trimmed)) onChange([...values, trimmed]);
    setInput('');
  };

  const handleKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      add(input);
    } else if (e.key === 'Backspace' && input === '' && values.length > 0) {
      onChange(values.slice(0, -1));
    }
  };

  return (
    <div className="flex flex-wrap gap-2 p-3 rounded-xl border bg-white min-h-[48px] transition-colors" style={{ borderColor: '#c7d7f5' }}>
      {values.map(v => (
        <span
          key={v}
          className="flex items-center gap-1 px-2.5 py-1 rounded-lg text-xs font-semibold"
          style={{ background: tagBg, color: tagColor }}
        >
          {v}
          <button type="button" onClick={() => onChange(values.filter(x => x !== v))} className="hover:opacity-60 ml-0.5">
            <X size={11} />
          </button>
        </span>
      ))}
      <input
        type="text"
        value={input}
        onChange={e => setInput(e.target.value)}
        onKeyDown={handleKey}
        onBlur={() => input.trim() && add(input)}
        placeholder={values.length === 0 ? placeholder : ''}
        className="flex-1 min-w-[140px] outline-none text-sm text-gray-700 bg-transparent"
      />
    </div>
  );
};

export default TagInput;
